export default __webpack_public_path__ + "static/media/gallery-wip-before-paint_01.9d55ff68.jpg";